import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const TriviaGameTimerScore = ({ score, title }) => {
  return (
    <>
      <Scoreboard>
        <h2>{title}</h2>
        <p>Score: {score}</p>
      </Scoreboard>
    </>
  )
}

const Scoreboard = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 3rem 0 1.5rem;

  @media screen and (min-width: 31.25em) {
    flex-direction: row;
    justify-content: space-between;
  }

  h2,
  p {
    margin: 0;
  }
`

TriviaGameTimerScore.defaultProps = {
  score: 0,
  title: 'Quiz',
}

TriviaGameTimerScore.propTypes = {
  score: PropTypes.number,
  title: PropTypes.string,
}

export default TriviaGameTimerScore
